import { FotoBlob } from './FotoBlob';

export class Noticia {

	Titulo: string;
	TextoContenido: string;
	FechaAlta: string;
	FechaBaja: string;
	ENTIDAD: any;
	Imagen: any; // FotoBlob;
	ExpiracionMensaje: string;
	expirado: Number;
	MostrarEdicion: boolean;
	Idiomas: Map<string, NoticiaIdiomaFormulario>;

	constructor(not?) {

		if (not) {
			this.Titulo = not.Titulo;
			this.TextoContenido = not.TextoContenido;
			this.FechaAlta = not.FechaAlta;
			this.FechaBaja = not.FechaBaja;
			this.MostrarEdicion = false;
			this.ENTIDAD = not;

			const now = new Date();
			const baja = this.FechaBaja? new Date(this.FechaBaja) : null; //new Date(this.FechaBaja);
			const alta = new Date(this.FechaAlta);
			this.expirado = this.getTipoCaducidad(now, baja, alta);
			this.ExpiracionMensaje = this.getEtiquetaCaducidad(now, baja, alta);

			this.Idiomas = new Map<string, NoticiaIdiomaFormulario>();
			not.IDIOMAS.forEach(element => {
				const aux = new NoticiaIdiomaFormulario(element);
				this.Idiomas.set(element.IDIOMA.Codigo, aux);
			});
		}
		else{
			this.Titulo = '';
			this.TextoContenido = '';
			this.FechaAlta = '';
			this.FechaBaja = '';
			this.MostrarEdicion = false;
			this.Idiomas = new Map<string, NoticiaIdiomaFormulario>();
		}
	 }

	 getEtiquetaCaducidad( now: Date, baja: Date, alta: Date){

		let respuesta = '';
		if ( baja === null || baja === undefined ){

			if ( alta.getTime() < now.getTime()){
				respuesta = 'Activo';
			}
			else{
				const diferencia = this.dayDiff(alta, now) ;
				if (diferencia > 30) {
					respuesta = 'Empieza el ' + alta.toLocaleDateString();
				}
				else {
					respuesta = 'Empieza en ' + diferencia + ' días';
				}
			}
		}
		else {
			// FechaBaja es posterior a hoy y FechaAlta es anterior a hoy
			if ( alta.getTime() < now.getTime() && now.getTime() < baja.getTime() ){
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 60){
					respuesta = 'Activo';
				}
				else if (diferencia > 30) {
					respuesta = 'Expira el ' + baja.toLocaleDateString();
				}
				else {
					respuesta = 'Expira en ' + diferencia + ' días';
				}

			}
			else if ( now.getTime() < alta.getTime() ){
				const diferencia = this.dayDiff(alta, now) ;
				if (diferencia > 30) {
					respuesta = 'Empieza el ' + alta.toLocaleDateString();
				}
				else {
					respuesta = 'Empieza en ' + diferencia + ' días';
				}
			}
			else if ( now.getTime() > baja.getTime()) {
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 30) {
					respuesta = 'Expirado el ' + baja.toLocaleDateString();
				}
				else {
					respuesta = 'Expirado hace ' + diferencia + ' días';
				}
			}

		}

		return respuesta;
	}

	getTipoCaducidad( now: Date, baja: Date, alta: Date){
		// Danger = 0
		// warning = 1
		// Succes = 2
		// normal = 3

		let respuesta = 0;
		if ( baja === null || baja === undefined ){

			if ( alta.getTime() <= now.getTime()){
				respuesta = 3;
			}
			else{
				const diferencia = this.dayDiff(alta, now) ;
				if (diferencia > 30) {
					respuesta = 2;
				}
				else {
					respuesta = 1;
				}
			}
		}
		else {
			// FechaBaja es posterior a hoy y FechaAlta es anterior a hoy
			if ( alta.getTime() < now.getTime() && now.getTime() < baja.getTime() ){
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 60){
					respuesta = 3;
				}
				else if (diferencia > 30) {
					respuesta = 2;
				}
				else {
					respuesta = 1;
				}

			}
			else if ( now.getTime() < alta.getTime() ){
				const diferencia = this.dayDiff(alta, now) ;
				if (diferencia > 30) {
					respuesta = 2;
				}
				else {
					respuesta = 1;
				}
			}
			else if ( now.getTime() > baja.getTime()) {
				const diferencia = this.dayDiff(baja, now) ;
				if (diferencia > 30) {
					respuesta = 0;
				}
				else {
					respuesta = 0;
				}
			}
		}

		return respuesta;
	}

	/* ** FUNCIONES VARIAS ** */
	// podriamos sacarlas a otro provider
	dayDiff(firstDate: Date, secondDate: Date) {
		const date2 = secondDate;
		const date1 = firstDate;
		if (date2 !== undefined && date2 !== null && date1 !== undefined && date1 !== null) {
			const timeDiff = Math.abs(date2.getTime() - date1.getTime());
			const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
			return diffDays;
		}
		else {
			return 999;
		}
	}
}

export class NoticiaIdiomaFormulario {

	Codigo: string;
	Titulo: string;
	TextoContenido: string;

	constructor(noticiaIdioma?) {

		if (noticiaIdioma) {
			this.Codigo = noticiaIdioma.IDIOMA.Codigo ? noticiaIdioma.IDIOMA.Codigo : '';
			this.Titulo = noticiaIdioma.Nombre ? noticiaIdioma.Nombre : '';
			this.TextoContenido = noticiaIdioma.Descripcion ? noticiaIdioma.Descripcion : '';
		}
		else{
			this.Codigo = '';
			this.Titulo = '';
			this.TextoContenido = '';
		}

	 }
}



// WEBPACK FOOTER //
// C:/Users/adri9/Escritorio/admin-everpath/src/app/domain/Noticia.ts